import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import { minuteOffsetToTime } from '@/components/events/helpers/minute-offset-to-time.helper';

type Translate = (key: string, params?: Record<string, string | number>) => string;

/** Banner title for inline schedule details under a slot (aligned with overlay `slotTitle` rules). */
export function getScheduleInlineSlotTitle(
  slot: FlowSlotDto,
  flowStartOffsetMinutes: number | undefined,
  t: Translate,
): string {
  const defaultVal = t('flows.detail.editDetails.title');
  const time =
    slot.computedOffsetMinutes !== undefined && flowStartOffsetMinutes !== undefined
      ? minuteOffsetToTime(flowStartOffsetMinutes + slot.computedOffsetMinutes)
      : t('common.N/A');
  switch (slot.contentType) {
    case 'Session': {
      const content = slot.content;
      const sessionTitle = typeof content === 'object' && content?.title ? content.title : undefined;
      return sessionTitle
        ? `${time} | ${sessionTitle}`
        : t('flows.detail.editDetails.sessionSlotContentNotPublished', {
            notPublished: t('common.notPublishedYet'),
          });
    }
    case 'Break':
      return slot?.title ? `${time} | ${slot.title}` : t('common.N/A');
    default:
      return defaultVal;
  }
}
